import { render, staticRenderFns } from "./UpdateOldToNewProduct.vue?vue&type=template&id=281b43fe"
import script from "./UpdateOldToNewProduct.vue?vue&type=script&lang=js"
export * from "./UpdateOldToNewProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports